import { render, staticRenderFns } from "./DeleteFolderWidget.vue?vue&type=template&id=4e074ef8"
import script from "./DeleteFolderWidget.vue?vue&type=script&lang=js"
export * from "./DeleteFolderWidget.vue?vue&type=script&lang=js"
import style0 from "./DeleteFolderWidget.vue?vue&type=style&index=0&id=4e074ef8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports